import React, { Component } from "react";
import checkicon from "../images/check-icon.svg"
import crossicon from "../images/cross-icon.svg"
import downarrowwhite from "../images/down-arrow-white.svg"
import downarrow from "../images/down-arrow.svg"



class MyTwinMyTreat extends Component {
render() {

return (
   <section className="twin-treatment-sec">
   <div className="container">
       <div className="row">
           <div className="col-12">
               <div className="title wow  fadeInUp" data-wow-duration="1s" data-wow-delay=".1s">
                   <h2>My Twin. My Treatment.</h2>
                   <span>Because you’re unique & so should be your treatment!</span>
                   <p className="mobile-version">Twin is the first in the world to offer <strong>Breakthrough digital twin technology</strong> enables doctors to solve the root cause of diabetes.</p>
                   <p>Twin is the first in the world to offer <strong>Breakthrough digital twin technology</strong> enables doctors to solve the root cause of diabetes.</p>
               </div>
               <div className="twin-treatment-inner">
                   <div className="row ">
                       <div className="col-md-6">
                           <div className="twin-treatment-box twin-treatment-box-first wow  fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                               <h3>What Twin treatment includes: 
                                   {/* <strong><img src={downarrowwhite} alt="" /></strong> */}
                                   </h3>
                               <ul>
                                   <li><img src={checkicon} alt="" />Scientific, Evidence based approach</li>
                                   <li><img src={checkicon} alt="" />Whole-body Digital Twin Technology</li>
                                   <li><img src={checkicon} alt="" />Comprehensive Health Tests</li>
                                   <li><img src={checkicon} alt="" />Precision Nutrition, Sleep, Activity</li>
                                   <li><img src={checkicon} alt="" />Health Coach</li>
                                   <li><img src={checkicon} alt="" />Doctor Consultations</li>
                                   <li><img src={checkicon} alt="" />24x7 Guidance</li>
                               </ul>
                           </div>
                       </div>
                       <div className="col-md-6">
                           <div className="twin-treatment-box wow  fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                               <h3><p>What Twin treatment is <span>NOT</span>:</p>
                                {/* <strong><img src={downarrow} alt="" /></strong> */}
                                </h3>
                               <ul className="twintreatulli">
                                   <li><img src={crossicon} alt="" />Giving medicines & artificial supplements</li>
                                   <li><img src={crossicon} alt="" />Dietary programs like Keto, Palio etc</li>
                                   <li><img src={crossicon} alt="" />Fasting or Crash dieting</li>
                                   <li><img src={crossicon} alt="" />Going to Wellness Retreat</li>
                                   <li><img src={crossicon} alt="" />Regular Diabetes management program</li>
                                   <li></li>
                                   <li></li>
                               </ul>
                           </div>
                       </div>
                   </div>
                   {/* <div className="twin-pack-btn  wow  fadeInUp" data-wow-duration="1s" data-wow-delay=".1s">
                       <ul>
                           <li><a href="#">Buy a Twin Pack</a></li>
                           <li><a className="see-how-btn" href="#"><span>See how it works</span></a></li>
                       </ul>
                   </div> */}
               </div>
           </div>
       </div>
   </div>
</section>
)
}
}
export default MyTwinMyTreat